export const redirectToTargetUrl = ({
  redirectUrl,
}: {
  redirectUrl: string | null | undefined;
}): void => {
  if (redirectUrl) {
    const isIframe = window.top !== window.self;
    if (isIframe && window.top) {
      // keeps browser history
      window.top.location.href = redirectUrl;
    } else {
      // does not keep browser history
      window.location.replace(redirectUrl);
    }
  }
};
